export default __webpack_public_path__ + "static/media/workflow.42cbf361.svg";